import { MicroappFbsResourceSlotModel } from './faciliti-slots';

export class MicroappFbsAccessoryGroupSlotsModel{
    label:string;
    startDateTime: Date;
    endDateTime: Date;
    isReservable: boolean;
    slots: MicroappFbsResourceSlotModel [];
}